console.log('Consert dropdown script loaded');

function initConsertDropdown() {
    console.log('Initializing consert dropdown functionality');
    
    // すべてのドロップダウンメニューを初期状態で非表示にする
    $('.consert-dropdown-menu').removeClass('show').css('display', 'none');
    console.log('Found', $('.consert-dropdown-menu').length, 'menus');
    console.log('Found', $('.consert-dropdown-toggle').length, 'toggles');
    
    // トグルボタンに直接イベントリスナーを追加
    $('.consert-dropdown-toggle').off('click.dropdown').on('click.dropdown', function(e) {
        console.log('Toggle clicked!', $(this).data('id'));
        e.preventDefault();
        e.stopPropagation();
        
        var dropdownId = $(this).data('id');
        var dropdown = $('#dropdown-' + dropdownId);
        console.log('Dropdown ID:', dropdownId, 'Found:', dropdown.length);
        
        // 他のドロップダウンを閉じる
        $('.consert-dropdown-menu').not(dropdown).removeClass('show').css('display', 'none');
        
        // 現在のドロップダウンを開閉
        if (dropdown.hasClass('show')) {
            dropdown.removeClass('show').css('display', 'none');
            console.log('Dropdown closed');
        } else {
            dropdown.addClass('show').css('display', 'block');
            console.log('Dropdown opened');
        }
    });
    
    // ドキュメントクリックでドロップダウンを閉じる
    $(document).off('click.dropdown').on('click.dropdown', function(e) {
        if (!$(e.target).closest('.consert-dropdown-wrapper').length) {
            $('.consert-dropdown-menu').removeClass('show').css('display', 'none');
        }
    });
}

$(document).on('turbolinks:load', function() {
    console.log('Turbolinks load event fired in consert_dropdown.js');
    initConsertDropdown();
});

// 初回読み込み時にも実行
$(document).ready(function() {
    console.log('Document ready in consert_dropdown.js');
    initConsertDropdown();
});
